import makeApiCall from "../master/axiosIndex";

const ReportsApis = {
  WorkOrderPortfolioSummary: (params: any) =>
    makeApiCall({
      url: "/reports/work-order-portfolio-summary",
      method: "get",
      params,
    }),
  workOrderStatusDistribution: (params: any) =>
    makeApiCall({
      url: "/reports/work-order-status-distribution",
      method: "get",
      params,
    }),
  executedWosPending: (params: any) =>
    makeApiCall({
      url: "/reports/executed-wos-pending",
      method: "get",
      params,
    }),
  executedWosApproved: (params: any) =>
    makeApiCall({
      url: "/reports/executed-wos-approved",
      method: "get",
      params,
    }),
  paymentsReleasedSummary: (params: any) =>
    makeApiCall({
      url: "/reports/payments-released-summary",
      method: "get",
      params,
    }),
  paymentReleasedVouchers: (params: any) =>
    makeApiCall({
      url: "/reports/payments-released-vouchers",
      method: "get",
      params,
    }),
  masterStatusByContractor: (params: any) =>
    makeApiCall({
      url: "/reports/master-status-by-contractor",
      method: "get",
      params,
    }),
  workOrderVarianceSummary: (params: any) =>
    makeApiCall({
      url: "/reports/work-order-variance-summary",
      method: "get",
      params,
    }),
  contractorAcceptanceTracker: (params: any) =>
    makeApiCall({
      url: "/reports/contractor-acceptance-tracker",
      method: "get",
      params,
    }),
  workExecutionPendingUpdates: (params: any) =>
    makeApiCall({
      url: "/reports/work-execution-pending-updates",
      method: "get",
      params,
    }),
  workExecutionApprovedVsRemaining: (params: any) =>
    makeApiCall({
      url: "/reports/work-execution-approved-vs-remaining",
      method: "get",
      params,
    }),
  versionControlAmendmentsRegister: (params: any) =>
    makeApiCall({
      url: "/reports/version-control-amendments-register",
      method: "get",
      params,
    }),
  raBillsStatusRegister: (params: any) =>
    makeApiCall({
      url: "/reports/ra-bills-status-register",
      method: "get",
      params,
    }),
  raBillAging: (params: any) =>
    makeApiCall({
      url: "/reports/ra-bill-aging",
      method: "get",
      params,
    }),
  deductionsLedger: (params: any) =>
    makeApiCall({
      url: "/reports/deductions-ledger",
      method: "get",
      params,
    }),
  paymentsRegister: (params: any) =>
    makeApiCall({
      url: "/reports/payments-register",
      method: "get",
      params,
    }),
  outstandingAging: (params: any) =>
    makeApiCall({
      url: "/reports/outstanding-aging",
      method: "get",
      params,
    }),
  contractorDueAmount: (params: any) =>
    makeApiCall({
      url: "/reports/contractor-due-amount",
      method: "get",
      params,
    }),
  contractorDueAmountDrilldown: (params: any) =>
    makeApiCall({
      url: "/reports/contractor-due-amount-drilldown",
      method: "get",
      params,
    }),
  woVsBudget: (params: any) =>
    makeApiCall({
      url: "/reports/wo-vs-budget",
      method: "get",
      params,
    }),
  contractorLedger: (params: any) =>
    makeApiCall({
      url: "/reports/contractor-ledger",
      method: "get",
      params,
    }),
  fetchContractorBySiteId: (id: number) =>
    makeApiCall({
      url: "/buyer/fetchContractorBySiteId",
      method: "get",
      params: { id },
    }),

  // SUBREPORTS APIS START ------------------------------
  workOrderPortfolioDrillDown: (params: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/reports/work-order-portfolio-drillDown`,
      params,
    }),
  contractorAcceptanceWODetails: (params: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/reports/contractor-acceptance-tracker-workOrder`,
      params,
    }),
  contractorAcceptanceWOLineDetails: (params: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/reports/contractor-acceptance-tracker-workOrderLine`,
      params,
    }),
  paymentsReleasedRABillsBreakup: (params: any): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/reports/payments-released-raBill-drillDown-summary`,
      params,
    }),
};

export default ReportsApis;
